import {
    LayoutDashboard,
    Users,
    Banknote,
    ShieldCheck,
    Landmark,
    BookOpen,
    Activity,
    ArrowLeftRight,
    List,
    Bell,
    IdCard,
    Key,
    Layers,
    Receipt,
    type LucideIcon,
} from "lucide-react";

const iconMap: Record<string, LucideIcon> = {
    faDashboard: LayoutDashboard,
    faUserGroup: Users,
    faMoneyBillWave: Banknote,
    faUserLock: ShieldCheck,
    faBank: Landmark,
    faJournalWhills: BookOpen,
    faColonSign: Activity,
    faMoneyBillTransfer: ArrowLeftRight,
    faList: List,
    faBell: Bell,
    faIdCard: IdCard,
    faKey: Key,
    faLayerGroup: Layers,
    faReceipt: Receipt,
};

export const getIcon = (iconName: string): LucideIcon | null => {
    return iconMap[iconName] || null;
};
